import { gql } from '@apollo/client'

export const JOB_BASE_INFO_FRAGMENT = gql`
    fragment JobBaseInfoFragment on Job {
        id
        company {
            id
            company_name
            schedule_contact_email
        }
        company_supervisor {
            id
            first_name
            last_name
            email_address
        }
        name
        phone
        key_map
        entered_date
        lat
        lon
        address_line_1
        address_line_2
        city
        state
        zip_code
        county
        mmg_mileage
        manchaca_mileage
        gate_code
        notes
        is_central_texas
        is_display
        is_commercial
        was_estimated
        temp_lat
        temp_lon
    }
`

export const JOB_DETAIL_FRAGMENT = gql`
    fragment JobDetailFragment on JobDetails {
        id
        plan_perimeter
        pebble_perimeter
        mmg_perimeter
        mmg_pebble_perimeter
        plan_sa
        plan_ia
        mmg_ia
        quoted_ia
        depth_low
        depth_high
        depth_mid
        is_cash_on_delivery
        is_critical_note
        critical_note
        awaiting_builder_date
        is_invoiced
        job_types {
            id
            name
        }
        job_category {
            id
            name
        }
        status {
            id
            name
        }
        pool_type {
            id
            name
        }
        spa_type {
            id
            name
        }
        is_in_print_queue

        general_comments {
            id
            job_detail_id
            date_created
            general_comment
        }
        
        gunite_details {
            id
            job_detail_id
            request_date
            requested_app_date
            flash_date
            finished_date
            scheduled_date
            total_yardage
            flash_yards
            notes
            crew_id
            is_spa_negative_edge
            is_spa_rolled_edge
            is_flash
            flash_crew_id
            work_order_ids {
                id
                date
                crew {
                    name
                }
            }
            boulder_work_order_ids {
                id
                date
            }
            gunite_history {
                id
                job_detail_id
                gunite_date
                status {
                    id
                    name
                }
                crew {
                    id
                    name
                    lookup_company_division_id
                }
                type {
                    id
                    name
                }
                yardage
                job_order {
                    id
                    name
                }
                notes
            }
        }
        boulder_details {
            id
            job_detail_id
            status {
                id
                name
            }
            addition {
                id
                name
                type
            }
            completed_date
            notes
        }
        pebble_details {
            id
            is_request_form
            prep_date
            app_date
            requested_app_date
            request_date
            scheduled_app_date
            detail_date
            
            work_order_ids {
                id
                date
                foreman {
                    name
                }
            }
            daily_work_order_ids {
                id
                date
            }
            prep_work_order_ids {
                id
                date
            }
            notes
            total_batches
            is_slurry_pickup
            slurry_pickup_notes
            is_can_show

            is_complete_chip_out
            is_update_channel_drain
            is_trim_tile
            is_trash_pick_up
            
            tile_information
            prep_crew_id
            app_crew_id
            detail_crew_id
            is_no_prep_print

            color_additions {
                id
                job_detail_id
                material_type{
                    id
                    name
                }
                color {
                    id
                    name
                    material_type {
                        id
                        name
                    }
                    pool_code
                    spa_code
                    price_level
                    condition
                    batch_ratio
                }
                additions {
                    id
                    name
                    quantity_per_batch
                    quantity_per_job
                    additive_product_id
                }
                pool_section {
                    id
                    name
                    additional_batches
                    is_add_pool_batches
                }
                batches_used
                notes
            }
            crew_information {
                id
                job_detail_id
                crew {
                    id
                    name
                }
                foreman {
                    id
                    name
                    crew_types {
                        id
                    }
                }
                date
                type
                status {
                    id
                    name
                }
                phase_type {
                    id
                    name
                }
                job_order {
                    id
                    name
                }
                slurry_pickup {
                    id
                    name
                }
                notes
            }
        }
        warranty_details {
            id
            job_detail_id
            is_will_need_to_return
            job_entered_by
            priority {
                id
                name
            }
            description {
                id
                name
            }
            description_notes
            special_instructions
            is_pebble_division
            is_gunite_division
            is_boulder_creations_division
            repair_supervisor {
                id
                name
            }
            other_repair_supervisor
            category {
                id
                name
            }
            ph
            cyanuric_acid
            sequestering_agent
            alkalinity
            chlorine
            calcium
            phosphates
            other_info
            report_notes
            contact_notes
            gunite_application_date
            gunite_crew {
                id
                name
            }
            pool_sections {
                id
                name
            }
            pool_info
            invoice_date
            creation_date
            imported_job_code

            schedule {
                id
                job_detail_id
                fieldworker {
                    id
                    name
                }
                start
                end
                completion
                additional_notes
            }
            pebble_details {
                id
                job_detail_id
                app_date
                detail_date
                color
                additions
                section
                crew
                detail_crew
            }

            work_order_ids {
                id
                date_completed
            }

            crew_repair_jobs{
                id
                job_detail_id
                date
                company_division{
                    id
                    name
                }
                crew{
                    id
                    name
                }
                status{
                    id
                    name
                }
                notes
                pebble_phase_type{
                    id
                    name
                }
            }
        }
        presite {
            id
            checkin_date
            slurry_type{
                id
                name
            }
            slurry_type_other
            slurry_type_notes
            rope_anchors
            umbrella_sleeves
            eyeballs_spa
            eyeballs_pool
            eyeballs_slotted
            fittings_pool
            fittings_spa
            fittings_other
            vgb_main_drains
            vgb_main_drains_by{
                id
                name
            }
            in_floor_nozzles
            install_trim_tile_mosaics
            estimated_number_of_batches
            estimated_number_of_hoses
            is_bond_cote
            is_complete_chip_out
            is_weeping
            comments {
                id
                job_detail_id
                date_created
                comment
            }

            is_water_on_site
            is_access_to_power
            feet_of_hose_needed
            is_pool_ready_to_shoot
            access_notes
            is_job_caved_in
            is_needs_inspection
            is_steel_done
            steel_notes
            is_stub_out
            is_depth_matches_plan
            additional_depth_notes
            plan_change_notes

            scheduled_date
            presite_supervisor{
                    id
                    name
            }
        }
    }
`

export const JOB_FRAGMENT = gql`
    ${JOB_DETAIL_FRAGMENT}
    ${JOB_BASE_INFO_FRAGMENT}
    fragment JobFragment on Job {
        ...JobBaseInfoFragment

        sub_jobs {
            ...JobDetailFragment
        }
    }
`

export const JOB_SEARCH_FRAGMENT = gql`
    fragment JobSearchFragment on JobSearchResult {
        id
        job_id
        job_detail_id
        name
        company
        address_line_1
        city
        entered_date
        color
        days_old
        supervisor
        is_request_form
        prep_date
        app_date
        finished_date
        status
        category
        category_id
        job_types {
            id
            name
        }
    }
`

export const ESTIMATE_FRAGMENT = gql`
fragment EstimateFragment on Estimate {
    id
    company {
        id
        company_name
    }
    company_supervisor {
        id
        first_name
        last_name
    }
    name
    phone
    key_map
    entered_date
    lat
    lon
    address_line_1
    address_line_2
    city
    state
    zip_code
    county
    mmg_mileage
    manchaca_mileage
    gate_code
    notes
    is_central_texas
    is_display
    is_commercial
    is_estimate
    is_preliminary
    is_approved_by_user_id
    was_estimated
}
`

export const GUNITE_WORK_ORDER_FRAGMENT = gql`
    fragment GuniteWorkOrderOfflineFragment on GuniteWorkOrder {
        id
        job_id
        job_detail_id
        work_order_job_number
        invoice_number
        date
        company {
            id
            customer_no
            is_credit_app
            company_name
            address_line_1
            address_line_2
            address_line_3
            city
            state
            zip_code
            business_phone
            telephone_ext
            fax_number
            company_email
            invoice_email
            web_page
            is_invoice_by_fax
            is_invoice_by_email
            is_invoice_by_mail
            note
            is_active
            pricing_email
        }
        company_supervisor {
            id
            first_name
            last_name
            phone_number
            email_address
            position
        }
        job_name
        crew {
            id
            name
            subdivision
            lookup_company_division_id
        }
        foreman {
            id
            name
            first_name
            last_name
            home_phone
            mobile_phone
            email_address
            mmg_label
            company_division {
                id
                name
            }
            job_position
            crew_types {
                id
                name
                subdivision
                lookup_company_division_id
            }
            is_active
        }
        property_owner {
            id
            first_name
            last_name
            mailing_address
            city
            state
            zip_code
            email_address
            phone_number
            secondary_phone_number
            fax_number
            note
        }
        address_line_1
        address_line_2
        city
        state
        zip_code
        county
        key_map
        is_no_spa
        is_spa_only
        is_separate_spa
        spa_raised_low
        spa_raised_mid
        spa_raised_high
        is_take_off_form_and_finish
        spa_wall_length
        spa_wall_thickness
        is_custom_spa
        is_deepend_spa
        is_rolled_beam_spa
        estimated_perimeter
        actual_perimeter
        is_walk_out_steps
        is_swimout
        is_sun_beach
        beach_entry
        benches
        second_set_of_steps
        is_flashed
        is_deep_end_ramp
        waterfall_pad_low
        waterfall_pad_mid
        waterfall_pad_high
        fountain_pad_low
        fountain_pad_mid
        fountain_pad_high
        notch_beam_low
        notch_beam_mid
        notch_beam_high
        equipment_pad_low
        equipment_pad_mid
        equipment_pad_high
        pool_wall_thickness
        pool_floor_thickness
        depth_low
        depth_mid
        depth_high
        pool_out_of_ground_length
        pool_out_of_ground_width
        pool_out_of_ground_height
        is_pool_out_of_ground_take_off_form_and_finish
        retaining_walls_length
        retaining_walls_width
        retaining_walls_height
        is_retaining_walls_take_off_form_and_finish
        raised_beams {
            id
            gunite_work_order_id
            length
            width
            height
            is_take_off_form_and_finish
        }
        wing_walls {
            id
            gunite_work_order_id
            length
            width
            height
            is_take_off_form_and_finish
        }
        skimmers
        steel
        is_skimmer_in_ramp
        muck_out_time
        yards
        pegboard
        extras
        free_form
        is_slide
        is_grotto
        is_gunited
        is_ayudo
        is_no_ayudo
        is_ayudo_poco
        is_ayudo_mucho
        mileage_one_way
        total_yards
        gate_code
    }
`

export const BOULDER_WORK_ORDER_FRAGMENT = gql`
    fragment BoulderWorkOrderOfflineFragment on BoulderWorkOrder {
        id
        job_id
        job_detail_id
        invoice_number
        date
        company{
            id
            company_name
            customer_no
            is_credit_app
            address_line_1
            address_line_2
            address_line_3
            city
            state
            zip_code
            business_phone
            telephone_ext
            fax_number
            pricing_email
            invoice_email
            company_email
            web_page
            is_invoice_by_fax
            is_invoice_by_email
            is_invoice_by_mail
            is_active
            note
            customer_contacts {
                id
                customer_id
                first_name
                last_name
                phone_number
                email_address
                position
            }
        }
        company_supervisor{
            id
            customer_id
            first_name
            last_name
            phone_number
            email_address
            position
        }
        job_name

        property_owner {
            id
            first_name
            last_name
            mailing_address
            city
            state
            zip_code
            email_address
            phone_number
            secondary_phone_number
            fax_number
            note
        }
        address_line_1
        address_line_2
        city
        state
        zip_code
        county
        key_map
        
        crew_members {
            id
            boulder_work_order_id
            employee_id
            manual_entry_name
        }
        other_comments
        problems_needing_attention
        work_done_today
        
        cement_used {
            id
            boulder_work_order_id
            color
            bags_used
        }
        pieces_of_half_inch_steel_used
        pieces_of_three_eighths_inch_steel_used
        coloring_used
        waterproofing_used
        yards_of_gunite_shot

        driver_in
        on_job
        break_start
        break_end
        leave_job
        driver_out

        mileage_one_way
    }
`

export const PEBBLE_WORK_ORDER_FRAGMENT = gql`
    fragment PebbleWorkOrderOfflineFragment on PebbleWorkOrder {
        id
        job_id
        job_detail_id
        invoice_number
        date
        foreman {
            id
            name
            first_name
            last_name
            home_phone
            mobile_phone
            email_address
            mmg_label
            company_division {
                id
                name
            }
            job_position
            crew_types {
                id
                name
                lookup_company_division_id
                subdivision
            }
            is_active
        }
        company {
            id
            company_name
            customer_no
            is_credit_app
            address_line_1
            address_line_2
            address_line_3
            city
            state
            zip_code
            business_phone
            telephone_ext
            fax_number
            pricing_email
            invoice_email
            company_email
            web_page
            is_invoice_by_fax
            is_invoice_by_email
            is_invoice_by_mail
            is_active
            note
            customer_contacts {
                id
                customer_id
                first_name
                last_name
                phone_number
                email_address
                position
            }
        }
        company_supervisor {
            id
            customer_id
            first_name
            last_name
            phone_number
            email_address
            position
        }
        job_name

        address_line_1
        address_line_2
        city
        state
        zip_code
        county
        key_map
        gate_code

        perimeter
        depth_low
        depth_high
        depth_mid
        mmg_sa
        plan_sa
        plan_ia
        quoted_ia
        mmg_ia
        walls

        color_additions {
            id
            pebble_work_order_id
            
            material_type {
                id
                name
            }
            price_level
            color {
                id
                name
                material_type {
                    id
                    name
                }
                pool_code
                spa_code
                price_level
                condition
                batch_ratio
            }
            pool_section {
                id
                name
                additional_batches
                is_add_pool_batches
            }
            additions {
                id
                name
                quantity_per_batch
                quantity_per_job
                additive_product_id
            }
            spa_code
            pool_code
        }

        spa {
            id
            name
        }
        spa_length
        spa_width
        spa_depth
        tanning_sunshelf
        total_steps_and_benches
        walk_out_step_swim_out
        beach_entry

        pool_de_ellos
        pool_mmg
        spa_de_ellos
        spa_mmg
        fountain_basin_de_ellos
        fountain_basin_mmg
        luces_other

        eyeballs_pool
        eyeballs_spa
        eyeballs_other

        umbrella_vb_sleeves_de_ellos
        umbrella_vb_sleeves_mmg
        is_umbrella_vb_sleeves_open_hole
        rope_anchors_de_ellos
        rope_anchors_mmg
        is_rope_anchors_open_hole

        drains {
            id
            name
        }
        ten_inch_vgb_de_ellos
        ten_inch_vgb_mmg
        ten_inch_sdx_de_ellos
        ten_inch_sdx_mmg
        mdx_de_ellos
        mdx_mmg
        channel_de_ellos
        channel_mmg
        pebble_top_mmg

        is_negative_spa
        is_oversized_spa
        spa2_length
        spa2_width
        spa2_height

        seashell_mix
        seashell_broadcast

        luminous
        luminous_colors {
            id
            name
            quantity_per_batch
            quantity_per_job
            additive_product_id
        }

        finish_barstools_or_table_post
        barstool_or_table_base_length
        barstool_or_table_base_width
        barstool_or_table_base_height
        negative_basin_length
        negative_basin_width
        negative_basin_height
        finish_fountain_length
        finish_fountain_width
        finish_fountain_height
        rock_waterline

        in_floor_nozzels
        is_install_in_floor_nozzels
        install_in_floor_nozzels

        slurry {
            id
            name
            type
        }
        is_separate_trip_to_drain_drill_hole
        pool_prep_or_prep_remodel {
            id
            name
        }
        is_complete_chip_out
        spa_prep_or_prep_remodel {
            id
            name
        }
        is_bond_kote

        is_install_trim_tile_mosaics
        is_finish_around_trim_tile_mosaics

        office_notes

        mmg_distance
        manchaca_distance
        total_batches
        total_batches_size {
            id
            name
        }

        prep_apply
        dos_tiradas
        luces_okay
        cerro

        material_types {
            id
            name
        }
        job_color
        piedra {
            id
            pebble_work_order_id
            color
            color_number
        }

        workers {
            id
            name
            first_name
            last_name
            home_phone
            mobile_phone
            email_address
            mmg_label
            company_division {
                id
                name
            }
            job_position
            crew_types {
                id
                name
                lookup_company_division_id
                subdivision
            }
            is_active
        }
        workers_other_1
        workers_other_2
        workers_other_3

        driver_in
        on_job
        break_start
        break_end
        leave_job
        driver_out

        mileage_one_way
    }
`

export const PEBBLE_DAILY_WORK_ORDER_FRAGMENT = gql`
    fragment PebbleDailyWorkOrderOfflineFragment on PebbleDailyWorkOrder {
        id
        job_id
        job_detail_id

        date
        company {
            id
            company_name
            customer_no
            is_credit_app
            address_line_1
            address_line_2
            address_line_3
            city
            state
            zip_code
            business_phone
            telephone_ext
            fax_number
            pricing_email
            invoice_email
            company_email
            web_page
            is_invoice_by_fax
            is_invoice_by_email
            is_invoice_by_mail
            is_active
            note
            customer_contacts {
                id
                customer_id
                first_name
                last_name
                phone_number
                email_address
                position
            }
        }
        job_name

        address_line_1
        city
        zip_code
        key_map

        mmg_distance
        manchaca_distance

        detail_wash_acid_wash
        slurry
        prep
        remodel
        repairs
        others

        color {
            id
            name
            material_type {
                id
                name
            }
            pool_code
            spa_code
            price_level
            condition
            batch_ratio

            recipe {
                id
                product {
                    id
                    supplier {
                        id
                        name
                        business_phone
                        fax_number
                        address
                        city
                        state
                        zip_code
                        web_page
                        notes
                        is_color_ingredient_supplier
                    }
                    category {
                        id
                        name
                    }
                    name
                    product_code
                    mmg_code
                    description
                    order_unit {
                        id
                        name
                    }
                    unit_of_measure {
                        id
                        name
                    }
                    quantity_per_unit
                    standard_cost
                    discount
                    list_price
                    reorder_level
                    target_level
                    targer_unit
                    is_discontinued
                    minimum_reorder_quantity
                    unit_weight
                }
                quantity
            }
        }
        multi_coat
        rolls_of_duct_tape
        rolls_of_plastic
        marble_sand
        acid
        waterproofing
        white_cement
        gray_cement
        water_stop

        workers {
            id
            name
            first_name
            last_name
            home_phone
            mobile_phone
            email_address
            mmg_label
            company_division {
                id
                name
            }
            job_position
            crew_types {
                id
                name
                lookup_company_division_id
                subdivision
            }
            is_active
        }
        workers_other_1
        workers_other_2
        workers_other_3

        driver_in
        on_job
        break_start
        break_end
        leave_job
        driver_out
        
        material_types {
            id
            name
        }
    }
`

export const WARRANTY_WORK_ORDER_FRAGMENT = gql`
    fragment WarrantyWorkOrderOfflineFragment on WarrantyWorkOrder {
        id
        job_id
        job_detail_id
        company {
            id
            company_name
            customer_no
            is_credit_app
            address_line_1
            address_line_2
            address_line_3
            city
            state
            zip_code
            business_phone
            telephone_ext
            fax_number
            pricing_email
            invoice_email
            company_email
            web_page
            is_invoice_by_fax
            is_invoice_by_email
            is_invoice_by_mail
            is_active
            note
            customer_contacts {
                id
                customer_id
                first_name
                last_name
                phone_number
                email_address
                position
            }
        }
        company_supervisor {
            id
            customer_id
            first_name
            last_name
            phone_number
            email_address
            position
        }
        job_name

        address_line_1
        city
        state
        zip_code
        gate_code

        gunite_date
        plaster_date
        detail_date

        gunite_crew {
            id
            name
            lookup_company_division_id
            subdivision
        }
        applicator
        detail_crew {
            id
            name
            lookup_company_division_id
            subdivision
        }

        problem_description_and_location
        scheduled_date
        problem_solution_and_work_performed
        date_completed
        tech_completed

        color_additions {
            id
            warranty_work_order_id

            material_type {
                id
                name
            }
            color {
                id
                name
                material_type {
                    id
                    name
                }
                pool_code
                spa_code
                price_level
                condition
                batch_ratio
            }
            price_level
            section {
                id
                name
                additional_batches
                is_add_pool_batches
            }
            addition {
                id
                name
                quantity_per_batch
                quantity_per_job
                additive_product_id
            }
            spa_code
            pool_code
        }
    }
`

export const DOCUMENT_FRAGMENT = gql`
    fragment DocumentOfflineFragment on Document {
        id
        job_id
        job_detail_id
        document_key
        document_url
        document_tags {
            id
            name
            is_active
        }
        file_name
        upload_date
    }
`

export const DEFAULT_LOOKUP_RESULTS = {
    customers: [],
    customer_contacts: [],
    homeowners: [],
    lookupJobType: [],
    lookupJobCategory: [],
    lookupPoolType: [],
    lookupSpaType: [],
    lookupJobStatus: [],
    lookupPebbleColor: [],
    lookupPebbleColorAdditive: [],
    lookupPebbleColorMaterialType: [],
    lookupPoolSection: [],
    lookupCrewTypes: [],
    lookupGuniteHistoryTypes: [],
    lookupJobOrder: [],
    lookupAddition: [],
    lookupEmployee: [],
    lookupRepairSupervisor: [],
    jobDescriptionJobType: [],
    lookupJobPriority: [],
    lookupWarrantyCategory: [],
    lookupSlurryType: [],
    lookupSlurryPickup: [],
    lookupVgbMainDrainsBy: [],
    estimates: [],
    lookupPebblePhaseType: [],
    presiteSupervisors: [],
    lookupDocumentTag: [],
}

export const LOOKUP_QUERY = gql`
query LookupQuery {
    customers: lookupCustomer {
        id
        company_name
        is_active
    }
    customer_contacts {
        id
        first_name
        last_name
        phone_number
        customer_id
    }
    homeowners {
        id
        first_name
        last_name
        phone_number
    }
    lookupJobType {
        id
        name
        show_gunite
        show_pebble
        show_warranty
    }
    lookupJobCategory {
        id
        name
    }
    lookupPoolType {
        id
        name
    }
    lookupSpaType {
        id
        name
    }
    lookupJobStatus {
        id
        name
        show_gunite
        show_pebble
        show_warranty

        show_gunite_history

        show_pebble_prep
        show_pebble_application
        show_pebble_detail
        show_pebble_slurry
    }
    lookupPebbleColor {
        id
        name
        material_type {
            id
            name
        }
        pool_code
        spa_code
        price_level
        condition
        batch_ratio
    }
    lookupPebbleColorAdditive {
        id
        name
        quantity_per_batch
        quantity_per_job
        additive_product_id
    }
    lookupPebbleColorMaterialType {
        id
        name
    }  
    lookupPoolSection {
        id
        name
        additional_batches
        is_add_pool_batches
    }
    lookupCrewTypes {
        id
        name
        lookup_company_division_id
        subdivision
        is_active
    }
    lookupGuniteHistoryTypes {
        id
        name
    }
    lookupJobOrder {
        id
        name
    }
    lookupAddition {
        id
        name
        type
    }
    lookupEmployee {
        id
        name
        is_active
        crew_types {
            id
        }
    }
    lookupRepairSupervisor {
        id
        name
        crew_types {
            id
        }
    }
    jobDescriptionJobType{
        job_type {
            id
            name
        }
        job_description {
            id
            name
        }
    }
    lookupJobPriority {
        id
        name
    }
    lookupWarrantyCategory {
        id
        name
    }
    lookupSlurryType {
        id
        name
        type
    }
    lookupVgbMainDrainsBy{
        id
        name
    }
    estimates: lookupEstimates {
        id
        name
    }
    lookupPebblePhaseType {
            id
            name
        }
    presiteSupervisors{
           id
           company_division_id
    }
    lookupDocumentTag {
        id
        name
        is_active
    }
    lookupCompanyDivisions{
        id
        name
    }
    lookupSlurryPickup {
        id
        name
        is_active
    }
}
`

export const HOMEOWNER_FRAGMENT = gql`
    fragment HomeownerFragment on Homeowner {
        id
        first_name
        last_name
        phone_number
        secondary_phone_number
        fax_number
        email_address
        mailing_address
        city
        state
        zip_code
        note
    }
`

export const CUSTOMER_FRAGMENT = gql`
    fragment CustomerFragment on Customer {
        id
        company_name
        customer_no
        is_credit_app
        address_line_1
        address_line_2
        address_line_3
        city
        state
        zip_code
        business_phone
        telephone_ext
        fax_number
        pricing_email
        company_email
        invoice_email
        schedule_contact_email
        web_page
        is_invoice_by_mail
        is_invoice_by_fax
        is_invoice_by_email
        is_active
        note
        customer_contacts {
            id
            customer_id
            first_name
            last_name
            email_address
            phone_number
            position 
        }
    }
`

export const GET_BASE_JOB_QUERY = gql`
    ${JOB_BASE_INFO_FRAGMENT}
    query getBaseJob ($id: ID!) {
        job(id: $id) {
            
            ...JobBaseInfoFragment

            sub_jobs {
                id
                job_category {
                    name
                }
            }
        }
    }
`

export const GET_JOB_DETAIL_QUERY = gql`
    ${JOB_DETAIL_FRAGMENT}
    query getJobDetail ($job_detail_id: ID!) {
        job_detail(job_detail_id: $job_detail_id) {
            ...JobDetailFragment
        }
    }
`

export const GET_JOB_QUERY = gql`
    ${JOB_FRAGMENT}
    query GetJob ($id: ID!) {
        job(id: $id) {
            ...JobFragment
        }
    }
`

export const GET_ESTIMATE_QUERY = gql`
    ${ESTIMATE_FRAGMENT}
    query GetEstimate ($id: ID!) {
        estimate(id: $id) {
            ...EstimateFragment
        }
    }
`

export const GET_PRESIGN = gql`
    mutation GetPresign ($key: String!, $contentType: String) {
        presign(key: $key, contentType: $contentType) {
                url
        }
    }
`

export const INSERT_DOCUMENTS_MUTATION = gql`
    mutation InsertDocuments($documents: DocumentUpload!) {
        insertDocuments(documents: $documents) {
         ...DocumentFragment
        }
    }
    ${DOCUMENT_FRAGMENT}
`

export const SUPERVISOR_DETAIL_QUERY = gql`
    query SupervisorDetail ($jobDetailId: ID!) {
        supervisorDetail(jobDetailId: $jobDetailId) {
            id

            plan_perimeter
            pebble_perimeter
            depth_low
            depth_mid
            depth_high
            plan_sa
            plan_ia

            is_critical_note
            critical_note
            awaiting_builder_date
            pool_type {
                name
            }
            
            job_types {
                name
            }
            status {
                name
            }
            job_category {
                id
                name
            }
            job {
                id
                company {
                    company_name
                }
                name
                address_line_1
                address_line_2
                city
                state
                zip_code
                gate_code
            }
            presite {
                id
                checkin_date
                slurry_type {
                    id
                    name
                }
                slurry_type_other
                slurry_type_notes
                rope_anchors
                umbrella_sleeves
                eyeballs_spa
                eyeballs_pool
                eyeballs_slotted
                fittings_pool
                fittings_spa
                fittings_other
                vgb_main_drains
                vgb_main_drains_by {
                    id
                    name
                }
                in_floor_nozzles
                install_trim_tile_mosaics
                estimated_number_of_batches
                estimated_number_of_hoses
                is_bond_cote
                is_complete_chip_out
                is_weeping
                comments {
                    id
                    job_detail_id
                    date_created
                    comment
                }

                is_water_on_site
                is_access_to_power
                feet_of_hose_needed
                is_pool_ready_to_shoot
                access_notes
                is_job_caved_in
                is_needs_inspection
                is_steel_done
                steel_notes
                is_stub_out
                is_depth_matches_plan
                additional_depth_notes
                plan_change_notes
            }
            gunite_details {
                id
                notes
            }
            pebble_details {
                id
                color_additions {
                    material_type {
                        name
                    }
                    color {
                        name
                    }
                    additions {
                        name
                    }
                }
                notes
            }
            warranty_details {
                id
                description_notes
            }
        }
    }

`
